


























































import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import companiesModel from "../models/company.model";

@Component({
  components: { EntityCrud },
})
export default class Companies extends Vue {
  model: any = companiesModel;

  title = "Empresas";
  tableColumns = ["name", "defaultPassword"];

  formColumns = ["name", "defaultPassword", "cnpj", "cnpjMatriz", "emailStatistics", "emailStatistics2", "idSAP", "inactive"];
  defaultEntity = {};
  //importação sap
  activePrompt: boolean = false;
  companies: any[];
  inactives: any[];
  companiesResponse: {};

  async sapSyncCompany() {
    console.log('Atualizar sap');
    //chamar api
    this.$vs.loading();
    try {
      const value = await companiesModel.sapSync({});
      console.log(value);
      this.companiesResponse = value;
      if (value) {
        this.companies = [];
        //juntar as subcompanies
        value.Empresas.forEach((emp: any) => {
          this.companies.push(emp);
          if (emp.SubEmpresas) {
            emp.SubEmpresas.forEach((sub: any) => {
              sub.RazaoSocial = ` -  ${sub.RazaoSocial}`;
              this.companies.push(sub);
            });
          }
        });
        console.log(this.companies);
        this.inactives = [...value.EmpresasInativadas];
        this.$vs.loading.close();
        this.activePrompt = true;
      }
    } catch (e) {
      console.log('Error', e);
      this.$vs.loading.close();
    }
  }

  copyResult() {
    const linhas = [];
    linhas.push("Status;Razão Social;0800;ID SAP");
    if (this.companies) {
      this.companies.forEach(c => {
        linhas.push(`${c.Status === "A" ? "ATUALIZADO" : (c.Status === "I" ? "INSERIDO" : "ERRO")};${c.RazaoSocial};${c.Codigo};${c.IDSAP}`);
      })
    }
    if (this.inactives) {
      this.inactives.forEach(c => {
        linhas.push(`INATIVO;${c.RazaoSocial};${c.Codigo ? c.Codigo: ''};${c.IDSAP ? c.IDSAP : ''}`);
      })
    }
    if (linhas.length > 0) {
      navigator.clipboard.writeText(linhas.join("\n"));
    }
  }

  async jsonResult() {
    console.log('copy json');
    if (!this.companiesResponse) {
      return;
    }
    try {
      const data = JSON.stringify(this.companiesResponse);
      const blob = new Blob([data], { type: "text/json" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "companies.json";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error saving file:", error);
    }
    /*      
    try {
      const handle = await window.showSaveFilePicker({
        suggestedName: 'companies.json',
        types: [{
          description: 'Arquivos JSON',
          accept: { 'text/json': ['.json'] },
        }],
      });
      const writableStream = await handle.createWritable();
      await writableStream.write(JSON.stringify(this.companiesResponse));
      await writableStream.close();
      console.log('File saved successfully!');
    } catch (error) {
      console.error('Error saving file:', error);
    }
    */
  }
}
